import { Badge } from '@mantine/core';
import { getStatusColor, getQualityScoreColor, getAdStrengthColor, getPerformanceLabelColor } from '@/types/googleAds';

interface StatusBadgeProps {
  status: string;
  type?: 'status' | 'qualityScore' | 'adStrength' | 'performance';
}

export function StatusBadge({ status, type = 'status' }: StatusBadgeProps) {
  const getColor = () => {
    switch (type) {
      case 'qualityScore':
        return getQualityScoreColor(parseInt(status, 10) || null);
      case 'adStrength':
        return getAdStrengthColor(status);
      case 'performance':
        return getPerformanceLabelColor(status);
      default:
        return getStatusColor(status);
    }
  };

  const getLabel = () => {
    switch (status) {
      case 'ENABLED':
        return 'Aktiv';
      case 'PAUSED':
        return 'Pausiert';
      case 'REMOVED':
        return 'Entfernt';
      case 'CANCELED':
        return 'Abgebrochen';
      case 'SUSPENDED':
        return 'Gesperrt';
      case 'CLOSED':
        return 'Geschlossen';
      case 'EXCELLENT':
        return 'Hervorragend';
      case 'GOOD':
        return 'Gut';
      case 'AVERAGE':
        return 'Durchschnittlich';
      case 'POOR':
        return 'Schlecht';
      case 'PENDING':
        return 'Ausstehend';
      case 'LEARNING':
        return 'Lernphase';
      case 'LOW':
        return 'Niedrig';
      case 'BEST':
        return 'Am besten';
      case 'BELOW_AVERAGE':
        return 'Unter Durchschnitt';
      case 'ABOVE_AVERAGE':
        return 'Über Durchschnitt';
      default:
        return status;
    }
  };

  return (
    <Badge color={getColor()} variant="light" size="sm">
      {getLabel()}
    </Badge>
  );
}
